module.exports = __webpack_public_path__ + "static/media/success-delivery.56c2470b.svg";